import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SectionEyebrow } from './SectionEyebrow';
import { CoverImage } from './CoverImage';
import { CTAButton } from './CTAButton';
const items = [{
  label: 'LIBRO PRINCIPAL',
  title: 'Glow Up Femenino en 30 Días',
  value: '$499 USD',
  image: 'https://cdn.magicpatterns.com/uploads/k66PeTHA9hMBB1F8f8BeHQ/42AD1564-0724-4E06-956B-1E54FA235ABC.png',
  description: 'La guía maestra de introspección y acción. 30 días de inmersión profunda para reconstruir tu seguridad y proyectar una imagen que refleje tu verdadera esencia interior.'
}, {
  label: 'BONO · 01',
  title: 'Eleva tus estándares y honra tu valor',
  value: '$200 USD',
  image: 'https://cdn.magicpatterns.com/uploads/nhed4qrh1e2fpNSZrdGvyC/Gemini_Generated_Image_o3coy2o3coy2o3co.png',
  description: 'El manual para la mujer que ya no negocia su paz. Aprende a establecer límites desde el amor y a sostener un estándar de vida alineado con tu dignidad y amor propio.'
}, {
  label: 'BONO · 02',
  title: 'Diario de sanación y claridad',
  value: '$200 USD',
  image: 'https://cdn.magicpatterns.com/uploads/dSf1KMiKPp2oVvK3GHV7AG/ChatGPT_Image_6_may_2026,_01_19_02_a.m._(1).png',
  description: 'Tu espacio sagrado. Una guía de journaling terapéutico diseñada para ordenar el caos mental y encontrar respuestas en el silencio.'
}, {
  label: 'BONO · 03',
  title: 'Declaraciones para volver a ti',
  value: '$100 USD',
  image: 'https://cdn.magicpatterns.com/uploads/5MGNjuQNrJY9EmSncq3zok/ChatGPT_Image_6_may_2026,_01_19_02_a.m._(2).png',
  description: 'Un compendio de decretos espirituales para reprogramar tu mente, sostener tu valor y caminar bajo la verdad de quién eres.'
}];
export function QueIncluye() {
  return <section className="py-20 md:py-32 px-6 bg-background" data-id="element-213">
      <div className="container max-w-[1100px] mx-auto" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-215">
          <SectionEyebrow text="La colección completa" className="mb-6" data-id="element-216" />
          <h2 className="text-4xl md:text-5xl text-foreground" data-id="element-217">
            Todo lo que incluye{' '}
            <span className="italic text-muted-foreground" data-id="element-218">tu compra</span>
          </h2>
        </motion.div>

        {/* Main Product Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-card rounded-2xl p-6 md:p-12 mb-6 flex flex-col md:flex-row items-center gap-8 md:gap-12 shadow-soft border border-border/50" data-id="element-219">
          <div className="w-[180px] md:w-[220px] shrink-0" data-id="element-220">
            <CoverImage src={items[0].image} alt={items[0].title} data-id="element-221" />
          </div>
          <div className="text-center md:text-left flex-1" data-id="element-222">
            <p className="text-xs uppercase tracking-[0.2em] text-accent mb-3" data-id="element-223">
              {items[0].label}
            </p>
            <h3 className="font-serif text-2xl md:text-3xl text-foreground mb-4 leading-tight" data-id="element-224">
              {items[0].title}
            </h3>
            <p className="text-muted-foreground font-light leading-relaxed mb-5" data-id="element-225">
              {items[0].description}
            </p>
            <p className="font-serif italic text-foreground text-lg" data-id="element-226">
              Valor: {items[0].value}
            </p>
          </div>
        </motion.div>

        {/* Bonuses Grid - Compact */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-227">
          {items.slice(1).map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-card rounded-2xl p-6 flex flex-col items-center text-center shadow-soft border border-border/50" data-id="element-228">
              <div className="w-[140px] mb-6" data-id="element-229">
                <CoverImage src={item.image} alt={item.title} data-id="element-230" />
              </div>
              <p className="text-xs uppercase tracking-[0.2em] text-accent mb-2" data-id="element-231">
                {item.label}
              </p>
              <h4 className="font-serif text-xl text-foreground mb-3 leading-tight" data-id="element-232">
                {item.title}
              </h4>
              <p className="text-sm text-muted-foreground font-light mb-4 flex-grow" data-id="element-233">
                {item.description}
              </p>
              <p className="font-serif italic text-foreground" data-id="element-234">
                Valor: {item.value}
              </p>
            </motion.div>)}
        </div>

        {/* Value Stack Summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-card rounded-2xl p-8 md:p-10 border border-border max-w-[700px] mx-auto" data-id="element-235">
          <div className="space-y-3 mb-6" data-id="element-236">
            {items.map((item, i) => <div key={i} className="flex items-center justify-between py-2 border-b border-border/50 last:border-0" data-id="element-237">
                <div className="flex items-center gap-3 min-w-0" data-id="element-238">
                  <Check className="w-4 h-4 text-accent shrink-0" strokeWidth={2} data-id="element-239" />
                  <span className="text-foreground font-light text-sm md:text-base truncate" data-id="element-240">
                    {item.title}
                  </span>
                </div>
                <span className="font-serif text-muted-foreground italic text-sm md:text-base shrink-0 ml-3" data-id="element-241">
                  {item.value}
                </span>
              </div>)}
          </div>

          <div className="text-center pt-4 border-t border-border" data-id="element-242">
            <p className="text-xs uppercase tracking-widest text-muted-foreground mb-2" data-id="element-243">
              Valor total
            </p>
            <p className="font-serif text-2xl text-muted-foreground line-through opacity-60 mb-3" data-id="element-244">
              $999 USD
            </p>
            <p className="text-xs uppercase tracking-widest text-accent mb-2" data-id="element-245">
              Hoy solo
            </p>
            <p className="font-serif text-5xl md:text-6xl text-foreground mb-6" data-id="element-246">
              $19.99 <span className="text-2xl" data-id="element-247">USD</span>
            </p>
            <CTAButton text="Quiero acceder a la colección" size="lg" data-id="element-248" />
          </div>
        </motion.div>
      </div>
    </section>;
}